export default __webpack_public_path__ + "static/media/postgresql.3be4beda.svg";